import { isDefined, not, notSingleEle } from '../../../utils/util';
import SingletonGlobalEvents from '../../../utils/SingletonGlobalEvents';
import EquipModel from './EquipModel';

class EquipCharacter {
  constructor(options) {
    const _ = this;

    if (not(isDefined)(options)) {
      throw new Error('EquipCharacter constructor require options object');
    }

    _.option = $.extend({
      wrap: null,
      data: null,
      global: window
    }, options);

    _.model = EquipModel.getInstance();

    _.globalEvents = SingletonGlobalEvents.getInstance();

    _.data = _.option.data;

    _.wrap = $(_.option.wrap);

    _.titleInput = null;

    _.totalStatBtn = null;

    _.proxy = {
      scrollEventHandler: null
    };

    _.global = _.option.global;
  }

  init() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) throw new Error('EquipCharacter wrap must be single element.');

    _.titleInput = $('.title input', _.wrap);

    _.totalStatBtn = $('.btn-totalstat', _.wrap);

    _.proxy.scrollEventHandler = $.proxy(_.scrollEventHandler, _);

    _.setInstance();

    return _;
  }

  setInstance() {
    const _ = this;

    switch (_.data.page) {
      case 'default':
        // none
        break;

      case 'view':
        _.disableTitleInput(true);
        break;

      case 'modify':
        // none
        break;
    }

    _.totalStatBtn.on('click', function (evt) {
      evt.preventDefault();

      $(_).trigger({type: EquipCharacter.EVT_SHOW_TOTAL_STAT});
    });

    _.globalEvents.addCallback('scroll', _.proxy.scrollEventHandler);
  }

  scrollEventHandler(evt) {
    const _ = this;

    if ($(_.global).scrollTop() <= _.model.CNB_HEIGHT) {
      $('.btn-totalstat', _.wrap).removeClass('btn-absolute');

    } else {
      $('.btn-totalstat', _.wrap).addClass('btn-absolute');
    }
  }

  disableTitleInput(flag) {
    this.titleInput.prop('disabled', flag);
  }

  getTitle() {
    return this.titleInput.val().trim() || '';
  }

  destroy(obj = null) {
    const _ = this;

    _.totalStatBtn.off('click');

    _.unsubscribeTotalStatBtnByScrollEvent();
  }

  /*
   * by setting qna board
   */
  removeTitleInput() {
    $('.title', this.wrap).remove();
  }

  unsubscribeTotalStatBtnByScrollEvent() {
    const _ = this;

    if (_.globalEvents) _.globalEvents.removeCallback('scroll', _.proxy.scrollEventHandler);
  }
}

EquipCharacter.EVT_SHOW_TOTAL_STAT = 'EVT_SHOW_TOTAL_STAT';

export default EquipCharacter;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/equip/EquipCharacter.js